import { render, staticRenderFns } from "./OneTimeOrders.vue?vue&type=template&id=b49c8d48"
import script from "./OneTimeOrders.vue?vue&type=script&lang=js"
export * from "./OneTimeOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports